import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Paper,
} from '@mui/material'
import {
  SmartToy as AgentsIcon,
  People as UsersIcon,
  Science as TestRunsIcon,
  Email as EmailIcon,
  Storage as MemoryIcon,
  MenuBook as KnowledgeIcon,
  SettingsApplications as EnvironmentIcon,
  Psychology as ModelsIcon,
  Hub as ClusterIcon,
  Speed as ProfilingIcon,
  Schedule as JobsIcon,
  ManageSearch as TicketManagementIcon,
  Download as DataExportIcon,
} from '@mui/icons-material'

const AdminDashboardPage = () => {
  const navigate = useNavigate()

  const adminTools = [
    {
      title: 'Agent Management',
      description: 'Configure and manage AI agents',
      icon: <AgentsIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/agents',
    },
    {
      title: 'User Management',
      description: 'Manage users and agent assignments',
      icon: <UsersIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/users',
    },
    {
      title: 'Test Runs',
      description: 'View and analyze agent test results',
      icon: <TestRunsIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/test-runs',
    },
    {
      title: 'Email Management',
      description: 'Configure email polling and listeners',
      icon: <EmailIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/email-management',
    },
    {
      title: 'Memory Browser',
      description: 'Browse and manage agent memory',
      icon: <MemoryIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/memory',
    },
    {
      title: 'Knowledge Management',
      description: 'Manage knowledge base and documents',
      icon: <KnowledgeIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/knowledge',
    },
    {
      title: 'Environment Config',
      description: 'View environment variables and configuration',
      icon: <EnvironmentIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/environment',
    },
    {
      title: 'LLM Models',
      description: 'View and manage available LLM models',
      icon: <ModelsIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/models',
    },
    {
      title: 'Cluster Management',
      description: 'Monitor and manage cluster nodes',
      icon: <ClusterIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/cluster',
    },
    {
      title: 'Background Jobs',
      description: 'Monitor and manage scheduled background jobs',
      icon: <JobsIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/jobs',
    },
    {
      title: 'Performance Profiling',
      description: 'Track and analyze system performance',
      icon: <ProfilingIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/profiling',
    },
    {
      title: 'Ticket Management',
      description: 'Search, view, and manage tickets',
      icon: <TicketManagementIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/ticket-management',
    },
    {
      title: 'Data Export',
      description: 'Export ticket conversations and notes',
      icon: <DataExportIcon sx={{ fontSize: 48, color: 'primary.main' }} />,
      path: '/admin/data-export',
    },
  ]

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mb: 4, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Admin Dashboard
        </Typography>
        <Typography variant="body1">
          Centralized administration and management tools for AgentFlow
        </Typography>
      </Paper>

      <Grid container spacing={3}>
        {adminTools.map((tool) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={tool.path}>
            <Card
              elevation={2}
              sx={{
                height: '100%',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardActionArea
                onClick={() => navigate(tool.path)}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  justifyContent: 'flex-start',
                }}
              >
                <CardContent sx={{
                  textAlign: 'center',
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 3,
                }}>
                  <Box sx={{ mb: 2 }}>
                    {tool.icon}
                  </Box>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {tool.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {tool.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default AdminDashboardPage
